<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("StockContainers.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("StockContainers.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 容器名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("StockContainers.Fields.container_name") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('StockContainers.Fields.container_name')"
                    rules="required"
                  >
                    <!-- 编辑信息 -->
                    <v-text-field
                      single-line
                      v-model="container.container_name"
                      :hint="isNew ? '' : $t('StockContainers.nameHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'container_name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <!-- 查看信息 -->
                  {{ container.container_name }}
                </v-col>
              </v-row>
              <!-- 容器编号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("StockContainers.Fields.container_code") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('StockContainers.Fields.container_code')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="container.container_code"
                      :hint="isNew ? '' : $t('StockContainers.codeHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'container_code')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ container.container_code }}
                </v-col>
              </v-row>
              <!-- 容器分类 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("StockContainers.Fields.container_categories") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('StockContainers.Fields.container_categories')"
                    rules="required"
                  >
                    <!-- 分类框 -->
                    <SearcherContainerCategories
                      v-model="containerCategorySelected"
                      no-label
                      unclearable
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'stock_container_code')
                          .concat(errors)
                      "
                    />
                  </ValidationProvider>
                </v-col>
                <!-- 查看 -->
                <v-col cols="9" md="7" v-else>
                  {{
                    container.container_category
                      ? container.container_category.category_name
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 条码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("StockContainers.Fields.bar_code") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('StockContainers.Fields.bar_code')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="container.bar_code"
                      :hint="isNew ? '' : $t('StockContainers.bar_codeHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'bar_code')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ container.bar_code }}
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("StockContainers.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="isView">
              <v-btn
                color="accent"
                block
                :disabled="loading && !container.id"
                @click="$emit('mode', 'edit')"
              >
                <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                {{ $t("CRUD.editInfo", [$t("StockContainers.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                :disabled="loading && !container.id"
                @click="save()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("StockContainers.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherContainerCategories from "@/components/plugins/SearcherContainerCategories";
import Container from "@/api/containers";

export default {
  props: ["value", "mode"],
  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherContainerCategories,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    serverErrors: [],
    container: {},
    containerCategorySelected: null,
  }),

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var container = JSON.parse(JSON.stringify(this.container));
            if (
              this.container.container_category &&
              this.container.container_category.id
            ) {
              container.stock_container_code = this.container.container_category.id;
            }
            delete container.container_category;
            //校验成功再提交
            Container.save(container.id, container)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.container);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          Container.fetchOne({id:this.value.id}).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.container = response.data.container;
                this.containerCategorySelected = this.container.container_category; // 用接口后再用
              }
            }.bind(this)
          );
        } else {
          // 新建仓库，初始化默认值
          this.container = {
            stock_id: this.$route.query.stock_id,
          };
          this.containerCategorySelected = null;
        }
        this.$scrollTop(); //返回顶部
      },
    },
    containerCategorySelected: {
      handler() {
        this.container.container_category_code = this.containerCategorySelected
          ? this.containerCategorySelected.category_code
          : "";
      },
    },
  },
};
</script>